import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Button from '../../components/Button';

import shapeImg1 from '../../assets/img/hero/shape-1-1.png';
import shapeImg2 from '../../assets/img/hero/shape-1-4.png';
import shapeImg3 from '../../assets/img/hero/shape-1-5.png';
import shapeImg4 from '../../assets/img/hero/shape-1-2.png';
import shapeImg5 from '../../assets/img/hero/shape-1-3.png';
import heroImg1 from '../../assets/img/hero/thumb-1-1.jpg';
import heroImg2 from '../../assets/img/hero/thumb-1-2.jpg';
import heroIcon from '../../assets/img/hero/icon-1.png';

const Hero = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="it-hero-area p-relative z-index grey-bg-2 fix">
      <ModalVideo
        channel="youtube"
        isOpen={isOpen}
        videoId="PO_fBTkoznc"
        onClose={() => openModal()}
      />
      <div className="it-hero-shape-1">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-hero-shape-4 d-none d-lg-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xxl-7 col-xl-6 col-lg-6">
            <div className="it-hero-content">
              <span
                className="it-section-subtitle-2 mb-15 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                الشراكات من أجل الصحة
              </span>
              <h1
                className="it-hero-title pb-5 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                رعاية لك <br />
                <span>الصحة</span> رعاية
              </h1>
              <div
                className="it-hero-text mb-30 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".7s"
              >
                <p>
                  من المهم أن تعتني بالمريض، وأن تتبع عملية التدريب، لتكون بطلاً
                  <br />
                  مع بعض العمل والألم الكبير. للوصول إلى أصغر التفاصيل.
                </p>
              </div>
              <div
                className="it-hero-button-wrapper wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".8s"
              >
                <div className="it-hero-button flex-wrap d-sm-flex align-items-center">
                  <div>
                    <Link className="it-btn-theme mr-30" to="/about-us">
                      <Button btnText="اكتشف المزيد" />
                    </Link>
                  </div>
                  <div className="it-hero-video">
                    <Link
                      className="play-icon pulse-anim popup-video"
                      to="#"
                      onClick={() => openModal()}
                    >
                      <i className="fa-sharp fa-solid fa-play"></i>
                    </Link>
                    <Link
                      className="popup-video"
                      to="/"
                      onClick={() => openModal()}
                    >
                      شاهدالآن
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-5 col-xl-6 col-lg-6">
            <div className="it-hero-right p-relative text-center text-lg-end">
              <div className="it-hero-thumb-1">
                <img src={heroImg1} alt="" />
              </div>
              <div className="it-hero-thumb-2">
                <img src={heroImg2} alt="" />
                <div className="it-hero-shape-5 d-none d-md-block">
                  <img src={shapeImg3} alt="" />
                </div>
              </div>
              <div className="it-hero-shape-2 d-none d-xl-block">
                <img src={shapeImg4} alt="" />
              </div>
              <div className="it-hero-shape-3 d-none d-md-block">
                <img src={shapeImg5} alt="" />
              </div>
              <div className="it-hero-doctor-wrap">
                <div className="it-hero-doctor-box d-flex align-items-center justify-content-start">
                  <div className="it-hero-doctor-icon">
                    <span>
                      <img src={heroIcon} alt="" />
                    </span>
                  </div>
                  <div className="it-hero-doctor-text text-end">
                    <span>200+</span>
                    <p>
                      أفضل الأطباء في العالم <br />
                      التشاور
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
